// components/About.js
const About = () => {
    return (
        <div className="max-w-6xl mx-auto px-4 py-8">
            <div className="text-center">
                <h1 className="text-3xl font-semibold mb-4">About Our Restaurant</h1>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="about-section">
                    <h2 className="text-xl font-semibold mb-2">Our Story</h2>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante
                        dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet.
                    </p>
                </div>
                <div className="about-section">
                    <h2 className="text-xl font-semibold mb-2">Our Mission</h2>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante
                        dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet.
                    </p>
                </div>
                <div className="about-section">
                    <h2 className="text-xl font-semibold mb-2">Location</h2>
                    <p>123 Main Street, City, Country</p>
                </div>
                <div className="about-section">
                    <h2 className="text-xl font-semibold mb-2">Contact Us</h2>
                    <p>Email: info@restaurant.com</p>
                    <p>Phone: +123 456 7890</p>
                </div>
            </div>
        </div>
    );
}

export default About
